<template>
  <div id="simple-edit">
    {{prevRoute}}
    
    <form :action="urlToSubmit" method="POST" class="mt-4">
      <input class="btn btn-outline-primary" type="submit" value="submit" />
      
      <div class="form-row">
      <div class="col-4" v-for="(m, i) in spec_name" :key="i" >
        <span v-if="myData[m]">
<label>{{ m }}</label>
        <input class="form-control" :name="m" placeholder="Enter " :value="myData[m]" />
        </span>
        </div>
      </div>


      <!-- <div class="form-group" v-for="(m, i) in myData" :key="i">
        <label>{{ i }}</label>
        <input class="form-control" :name="i" placeholder="Enter " :value="m" />
      </div> -->
      <input class="btn btn-outline-primary" type="submit" value="submit" />
    </form>
    <ul></ul>

  </div>
</template>

<script>
import { ApiTls } from "../app/tools/ApiTls";
// this.$route.params.feederId
// /simple-edit/:tableName/:whereName/:whereValue
import { UrlTls } from '../app/tools/UrlTls';

export default {
  name: "SimpleEdit_copy_for_D",
  data() {
    return {
      myData: {},
      prevRoute: null,
      spec_name:['r_spec','s_spec','t_spec','n_spec','l_spec', 'pole_num', 'real_length'],
    };
  },
  beforeRouteEnter(to, from, next) {
  next(vm => {
    vm.prevRoute = from
  })
},
  methods: {
    saveData(res) {
      this.myData = res.data[0];
    },
    sentData() {
     
      
    },
    // addFeeder(){
    //   if(this.myData.feeder_id_arr &&this.feederId_tmp.length>0 ){
    //    this.myData.feeder_id_arr=  this.myData.feeder_id_arr.split("_").concat(this.feederId_tmp).join("_");
    //    this.feederId_tmp = "";
    //   }
    // },
    // removeFeeder(){
    //    if(this.myData.feeder_id_arr){
    //    this.myData.feeder_id_arr=  this.myData.feeder_id_arr.split("_").filter(r=>r&r!=this.feederId_tmp).join("_");
    //    this.feederId_tmp = "";
    //   }
    // },
  },
  computed: {
    urlToSubmit() {
      return (
        UrlTls.getBaseUrl()+"/free/" +
        this.$route.params.tableName +
        "/" +
        this.$route.params.whereName +
        "/" +
        this.$route.params.whereValue
      );
    },
  
  },
  mounted() {
    ApiTls.getFreeData(
      this.$route.params.tableName,
      this.$route.params.whereName,
      this.$route.params.whereValue,
      this.saveData
    );
  },
};
</script>

<style>
</style>